import { render, staticRenderFns } from "./collect_list.vue?vue&type=template&id=7218b944&scoped=true&"
import script from "./collect_list.vue?vue&type=script&lang=js&"
export * from "./collect_list.vue?vue&type=script&lang=js&"
import style0 from "./collect_list.vue?vue&type=style&index=0&id=7218b944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218b944",
  null
  
)

export default component.exports